import { render, staticRenderFns } from "./ImportsTable.vue?vue&type=template&id=22c3a1b4&scoped=true"
import script from "./ImportsTable.vue?vue&type=script&lang=ts"
export * from "./ImportsTable.vue?vue&type=script&lang=ts"
import style0 from "./ImportsTable.vue?vue&type=style&index=0&id=22c3a1b4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22c3a1b4",
  null
  
)

export default component.exports